export const terms = Object.freeze({
    notifications: 'Notifications',
    notificationsIntro: 'Edit your notification settings',
    notificationsBrokerUpdates: 'Broker Metrics Updates',
    savedAgents: 'Saved Agents',
    notificationsSavedAgentsDescription: 'While my campaign is active, send me a summary of the activity and engagement for Saved Agents.',
    receiveNotifications: 'Receive Notifications',
    saveChanges: 'Save Changes',
    weekly: 'Weekly',
    every2Weeks: 'Every 2 weeks',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    never: 'Never',
    fortnightly: 'Fortnightly'
});

export const FREQUENCY_NEVER = Object.freeze({
    label: terms.never,
    value: 'Never'
});

export const frequencyOptions = [
    { label: terms.weekly, value: 'Weekly' },
    { label: terms.every2Weeks, value: 'Fortnightly' },
    { label: terms.monthly, value: 'Monthly' },
    { label: terms.quarterly, value: 'Quarterly' },
    FREQUENCY_NEVER
];

export const FORTNIGHTLY_VARIANTS = Object.freeze(['Fortnightly_0', 'Fortnightly_1']);
